import React from 'react';
import {Button, Checkbox, Col, List, Row, Skeleton, Tooltip} from "antd";
import TooltipIcon from "../Boilerplate/TooltipIcon";
import {UserCustom} from "../Boilerplate/UserCustom";
import {compose} from "redux";
import {connect} from "react-redux";
import {getCompanyEmployees, removeCompanyEmployee, updateCompanyEmployeePermissions} from "../../actions/companies";
import {withTransparentLoading} from "../Boilerplate/deferLoaderHoc";
import {currentEffectiveUserId} from "../../reducers/ui";
import {nameSort} from "../../common/sorters";
import SearchBox from "../Boilerplate/SearchBox";

class _CompanyEmployees extends React.Component {
  state = { searchTerm: null };

  handleSearch = searchTerm => this.setState({searchTerm});

  handleRemove = (id) => {
    const { onRemove } = this.props;
    onRemove && onRemove(id);
  };

  handleUpdate = (id, permissions) => {
    const { onUpdate } = this.props;
    onUpdate && onUpdate(id, permissions);
  };

  render() {
    const { employees, currentUser, profile } = this.props;
    let list = Object.values(employees);
    const { searchTerm } = this.state;
    if (searchTerm) {
      const search = new RegExp(searchTerm, 'i');
      list = list.filter(contact => {
        // Extract searchable fields from user object and user company object
        const obj = (({ firstname, lastname, title, email, phone, cell, fax }) => ({ firstname, lastname, title, email, phone, cell, fax }))(contact);
        return Object.values(obj)
          .map(i => search.test(i)) // Test search term against each field
          .filter(i => i).length; // Grab only results with one or more match
      });
    }
    list.sort(nameSort);
    const canRemoveSelf = list.filter(e => e.companyadmin).length > 1 || list.length === 1;
    return (
      <React.Fragment>
        <div style={{textAlign: 'right'}}>
          <SearchBox
            placeholder="Search employees by name, email, or phone"
            onChange={this.handleSearch}
            className='contact-search control-search'
            interactive
          />
        </div>
        <List
          size={'small'}
          dataSource={list}
          locale={{ emptyText: 'Loading' }}
          header={profile.companyadmin &&
          <List.Item actions={[<Button disabled style={{ visibility: 'hidden' }} icon={'user-delete'}
                                       className={'color-secondary-1-0 border-secondary-1-0'}/>]}>
            <Skeleton title={false} loading={false} active>
              <List.Item.Meta title={<span></span>}/>
              <Row type={'flex'} gutter={4} justify={'end'} className={'company-permissions'}>
                <Col span={3}>Bid Creator<br/><TooltipIcon
                  tooltipProps={{ className: 'color-primary-2' }}
                  type={'question-circle'} title={'User can create bids'}/></Col>
                <Col span={3}>Project<br/>Creator<br/><TooltipIcon
                  tooltipProps={{ className: 'color-primary-2' }}
                  type={'question-circle'} title={'User can create projects'}/></Col>
                <Col span={3}>Company Admin<br/><TooltipIcon
                  tooltipProps={{ className: 'color-primary-2' }}
                  type={'question-circle'} title={'User can manage company'}/></Col>
              </Row>
            </Skeleton>
          </List.Item>
          }
          renderItem={employee =>
            <List.Item actions={[
              profile.companyadmin && <Tooltip
                title={employee.id === currentUser ?
                  canRemoveSelf ?
                    'Remove yourself from company' :
                    'You must appoint another admin before you can remove yourself from the company' :
                  'Remove user from company'}
              >
                <Button disabled={employee.id === currentUser && !canRemoveSelf} icon={'user-delete'}
                        className={'color-secondary-1-0 border-secondary-1-0'}
                        onClick={() => this.handleRemove(employee.id)}/>
              </Tooltip>
            ]}>
              <Skeleton title={false} loading={false} active>
                <List.Item.Meta
                  title={<UserCustom id={employee.id} dataPath={['employees']} dataItems={['name', 'email']}/>}/>
                {profile.companyadmin &&
                <Row type={'flex'} justify={'end'} className={'company-permissions'}>
                  <Col span={3}><Checkbox
                    checked={employee.isbidcreator}
                    // onChange={e => this.handleUpdate(employee.id, {isbidcreator: e.target.value})}
                    disabled
                  /></Col>
                  <Col span={3}><Checkbox
                    checked={employee.isprojectcreator}
                    // onChange={e => this.handleUpdate(employee.id, {isprojectcreator: e.target.value})}
                    disabled
                  /></Col>
                  <Col span={3}><Checkbox
                    checked={employee.companyadmin}
                    onChange={e => this.handleUpdate(employee.id, { companyadmin: e.target.checked })}
                    disabled={employee.id === currentUser}
                  /></Col>
                </Row>}
              </Skeleton>
            </List.Item>
          }
        />
      </React.Fragment>
    );
  }
}

export const CompanyEmployees = compose(
  connect(
    (state, props) => ({
      employees: state.employees,
      currentUser: currentEffectiveUserId(state),
      profile: state.profile,
    }),
    (dispatch, props) => ({
      loader: () => dispatch(getCompanyEmployees()),
      onRemove: id => dispatch(removeCompanyEmployee(id)),
      onUpdate: (id, permissions) => dispatch(updateCompanyEmployeePermissions(id, permissions)),
    })
  ),
  withTransparentLoading,
)(_CompanyEmployees);



// WEBPACK FOOTER //
// ./src/components/Settings/CompanyEmployees.js